// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__E8ee_","inputWrap":"styles_inputWrap__3xY0C","input":"styles_input__KVQ3D"};